/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type GoalOverviewPayoutFrequency = (typeof GoalOverviewPayoutFrequency)[keyof typeof GoalOverviewPayoutFrequency] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalOverviewPayoutFrequency = {
  one_time: "one_time",
  regular: "regular",
} as const;
